const status = {
	TRANSACTION_STATUS_SUCCESS: "success",
	TRANSACTION_STATUS_FAILED: "failed",
	TRANSACTION_STATUS_PENDING: "pending"
}

const service = {
	TRANSACTION_SERVICE_PAYMENT: "pay",
	TRANSACTION_SERVICE_INQUIRY: "inq",
	TRANSACTION_SERVICE_DEPOSIT: "dep",
	TRANSACTION_SERVICE_ADJUSTMENT: "adj",
	TRANSACTION_SERVICE_SETTLEMENT: "stl",
}

const tipeTrxBanking = {
	TRANSACTION_ON_US: 'on us',
	TRANSACTION_OFF_US: 'off us',
}

export function serviceColors() {
	const colors = {}
	colors[service.TRANSACTION_SERVICE_PAYMENT] = '#135200'
	colors[service.TRANSACTION_SERVICE_INQUIRY] = '#006d75'
	colors[service.TRANSACTION_SERVICE_DEPOSIT] = '#0050b3'
	colors[service.TRANSACTION_SERVICE_ADJUSTMENT] = '#0050b3'
	colors[service.TRANSACTION_SERVICE_SETTLEMENT] = '#0050b3'

	return colors
}

export function statusColors() {
	const colors = {}
	colors[status.TRANSACTION_STATUS_SUCCESS] = '#87d068'
	colors[status.TRANSACTION_STATUS_PENDING] = '#faad14'
	colors[status.TRANSACTION_STATUS_FAILED] = '#b1093e'

	return colors
}

export function transactionServices() {
	return [
		service.TRANSACTION_SERVICE_INQUIRY,
		service.TRANSACTION_SERVICE_PAYMENT
	]
}

export function financialServices() {
	return [
		service.TRANSACTION_SERVICE_SETTLEMENT,
		service.TRANSACTION_SERVICE_DEPOSIT,
		service.TRANSACTION_SERVICE_ADJUSTMENT
	]
}

export function tipeTrxBankindColors() {
	const colors = {}
	colors[tipeTrxBanking.TRANSACTION_ON_US] = '#87d068'
	colors[tipeTrxBanking.TRANSACTION_OFF_US] = '#b1093e'

	return colors
}

export {
	status,
	service,
	tipeTrxBanking,
}
